module.exports = __webpack_public_path__ + "img/boat_enabled.4caa8ac0.svg";